
import { Bar } from "vue-chartjs";

/**
 * Grafik tren kunjungan 7 hari (Ralan/IGD/Ranap) untuk Dashboard Super Admin.
 * Mengikuti pola chart existing (vue-chartjs `extends: Bar` + renderChart).
 */
export default {
  extends: Bar,
  props: {
    dataSet: {
      type: Object,
      default: () => ({ labels: [], ralan: [], igd: [], ranap: [] })
    }
  },
  computed: {
    chartData(): any {
      return {
        labels: this.dataSet.labels,
        datasets: [
          {
            label: "Rawat Jalan",
            data: this.dataSet.ralan,
            backgroundColor: "#1976d2"
          },
          {
            label: "IGD",
            data: this.dataSet.igd,
            backgroundColor: "#e53935"
          },
          {
            label: "Rawat Inap",
            data: this.dataSet.ranap,
            backgroundColor: "#43a047"
          }
        ]
      };
    },
    chartOptions(): any {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: { position: "bottom" },
        scales: {
          yAxes: [{ ticks: { beginAtZero: true, precision: 0 } }]
        }
      };
    }
  },
  watch: {
    dataSet: {
      deep: true,
      handler() {
        (this as any).render();
      }
    }
  },
  mounted() {
    (this as any).render();
  },
  methods: {
    render() {
      (this as any).renderChart(this.chartData, this.chartOptions);
    }
  }
};
